import { initializeApp } from "https://www.gstatic.com/firebasejs/12.0.0/firebase-app.js";
import { getDatabase, ref, push, set } from "https://www.gstatic.com/firebasejs/12.0.0/firebase-database.js";
import * as XLSX from "https://cdn.sheetjs.com/xlsx-0.20.0/package/xlsx.mjs";

const firebaseConfig = {
    apiKey: "AIzaSyC7vxmfLaRQwE6fRGp7USsBZI6vLqyGNMk",
    authDomain: "jazmin-int---wishlist-data.firebaseapp.com",
    databaseURL: "https://jazmin-int---wishlist-data-default-rtdb.firebaseio.com",
    projectId: "jazmin-int---wishlist-data",
    storageBucket: "jazmin-int---wishlist-data.firebasestorage.app",
    messagingSenderId: "679601322214",
    appId: "1:679601322214:web:fb3c2bdbad8ebae0166327"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const STOREFRONT_ACCESS_TOKEN = "16e6e830070d6cf54ae1ff850dae0059";

const STORAGE_KEY = "custom_wishlist";
const wishlistContainer = document.getElementById("wishlist-products-container");
const wishlistEmpty = document.getElementById("wishlist-empty");
const clearBtn = document.getElementById("wishlist-clear-btn");
const wishlistCountEls = document.querySelectorAll(".wishlist-icon-count");
const downloadBtn = document.getElementById("downloadExcelBtn");
const viewControlWrapper = document.querySelector(".wishlist-view-controls");
const isWishlistPage = !!wishlistContainer;

const getWishlist = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
const setWishlist = (items) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

const updateCount = () => {
  const count = getWishlist().length;
  wishlistCountEls.forEach(el => el.textContent = count);
  if (clearBtn) clearBtn.style.display = count > 0 ? "inline-block" : "none";
  if (downloadBtn) downloadBtn.style.display = count > 0 ? "inline-block" : "block";
  if (!isWishlistPage && wishlistEmpty) wishlistEmpty.remove();
  if (isWishlistPage && wishlistEmpty) wishlistEmpty.style.display = count === 0 ? "block" : "none";
};

const isInWishlist = (handle) => getWishlist().includes(handle);

const updateAllButtons = () => {
  document.querySelectorAll('[data-handle], [data-product-handle]').forEach(btn => {
    const handle = btn.dataset.handle || btn.dataset.productHandle;
    const inWishlist = isInWishlist(handle);
    btn.classList.toggle("active", inWishlist);
    btn.setAttribute("aria-pressed", inWishlist);
  });
};

const logWishlistEvent = (handle, action) => {
  // log async in background
  (async () => {
    try {
      let productName = handle ? "Unknown Product" : null;
      if (handle) {
        try {
          const query = `{ productByHandle(handle: "${handle}") { title } }`;
          const res = await fetch("/api/2023-04/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({ query })
          });
          const json = await res.json();
          productName = json?.data?.productByHandle?.title || productName;
        } catch {}
      }
      const eventRef = push(ref(db, "wishlist_events"));
      await set(eventRef, {
        productHandle: handle || null,
        productName,
        action,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height
      });
    } catch (err) {
      console.error("Error logging wishlist event:", err);
    }
  })();
};

const toggleWishlist = (handle) => {
  let items = getWishlist();
  const isRemoving = items.includes(handle);

  // Update UI instantly
  if (isRemoving) {
    items = items.filter(h => h !== handle);
    logWishlistEvent(handle, "removed");
    if (isWishlistPage) {
      const card = document.querySelector(`.wishlist-product-card[data-handle="${handle}"]`);
      if (card) card.remove();
      if (wishlistContainer && wishlistContainer.querySelectorAll(".wishlist-product-card").length === 0 && wishlistEmpty) {
        wishlistEmpty.style.display = "block";
        wishlistContainer.style.display = "none";
      }
    }
  } else {
    items.push(handle);
    logWishlistEvent(handle, "added");
    if (isWishlistPage) renderWishlistProducts();
  }

  setWishlist(items);
  updateCount();
  updateAllButtons();
};

document.body.addEventListener("click", (e) => {
  const btnWishlist = e.target.closest(".btn-wishlist, .wishlist-btn, .wishlist-action-btn");
  const btnClear = e.target.closest("#wishlist-clear-btn");

  if (btnWishlist) {
    const handle = btnWishlist.dataset.handle || btnWishlist.getAttribute("data-handle") || btnWishlist.getAttribute("data-product-handle");
    if (!handle) return;
    e.preventDefault();
    toggleWishlist(handle);
  } else if (btnClear) {
    e.preventDefault();
    const items = getWishlist();
    items.forEach(handle => logWishlistEvent(handle, "removed"));
    setWishlist([]);
    updateCount();
    updateAllButtons();
    if (isWishlistPage) renderWishlistProducts();
    logWishlistEvent(null, "wishlist_cleared");
  }
});

updateCount();
updateAllButtons();

if (isWishlistPage) {
  const formatCurrency = (amount, currencyCode) =>
    new Intl.NumberFormat("en", { style: "currency", currency: currencyCode }).format(amount);

  const productCache = new Map();
  const fetchProductByHandlePage = async (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);
    const query = `
      {
        productByHandle(handle: "${handle}") {
          title
          handle
          onlineStoreUrl
          availableForSale
          images(first: 2) { edges { node { originalSrc altText } } }
          priceRange { minVariantPrice { amount currencyCode } }
          compareAtPriceRange { minVariantPrice { amount } }
        }
      }`;
    const res = await fetch("/api/2023-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({ query })
    });
    const json = await res.json();
    const product = json?.data?.productByHandle || null;
    if (product) productCache.set(handle, product);
    return product;
  };

  const createWishlistCard = (product) => {
    const card = document.createElement("div");
    card.className = "wishlist-product-card";
    card.dataset.handle = product.handle;
    const title = product.title;
    const url = product.onlineStoreUrl;
    const firstImage = product.images.edges[0]?.node.originalSrc || "";
    const secondImage = product.images.edges[1]?.node.originalSrc || "";
    const price = parseFloat(product.priceRange.minVariantPrice.amount);
    const currency = product.priceRange.minVariantPrice.currencyCode;
    const compare = parseFloat(product.compareAtPriceRange.minVariantPrice?.amount || 0);
    const onSale = compare > price;
    const percentOff = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
    const priceFormatted = formatCurrency(price, currency);
    const compareFormatted = formatCurrency(compare, currency);

    card.innerHTML = `
      <div class="custom-card">
        <button class="wishlist-btn active" data-handle="${product.handle}" aria-pressed="true">
          <i class="fa-solid fa-heart text-red-500"></i>
        </button>
        <a href="${url}">
          <div class="custom-card-image-wrapper">
            ${firstImage ? `<img src="${firstImage}" alt="${title}" class="custom-card-image primary-image" loading="lazy">` : ""}
            ${secondImage ? `<img src="${secondImage}" alt="${title} hover" class="custom-card-image secondary-image" loading="lazy">` : ""}
          </div>
          <div class="custom-card-content">
            <h3 class="custom-card-title">${title}</h3>
            <p class="custom-card-price">
              ${onSale
                ? `<span class="price-sale">${priceFormatted}</span><span class="price-compare">${compareFormatted}</span>`
                : `${priceFormatted}`}
            </p>
            <div class="custom-card-badges">
              ${onSale ? `<div class="sale-badge"><span>${percentOff}% Off</span></div>` : ""}
              ${!product.availableForSale ? `<div class="soldout-badge"><span>Sold Out</span></div>` : ""}
            </div>
          </div>
        </a>
      </div>`;
    return card;
  };

  var renderWishlistProducts = async () => {
    const handles = getWishlist();
    wishlistContainer.innerHTML = "";
    if (!handles.length) {
      wishlistContainer.style.display = "none";
      if (wishlistEmpty) wishlistEmpty.style.display = "block";
      return;
    }
    wishlistContainer.style.display = "grid";
    if (wishlistEmpty) wishlistEmpty.style.display = "none";

    const inStockProducts = [];
    const soldOutProducts = [];

    await Promise.all(handles.map(async (handle) => {
      const product = await fetchProductByHandlePage(handle);
      if (product) {
        if (product.availableForSale) {
          inStockProducts.push(product);
        } else {
          soldOutProducts.push(product);
        }
      }
    }));

    [...inStockProducts, ...soldOutProducts].forEach((product) => {
      wishlistContainer.appendChild(createWishlistCard(product));
    });
  };

  renderWishlistProducts();

  if (viewControlWrapper) viewControlWrapper.style.display = "none";

  const updateViewBasedOnScreenSize = () => {
    const width = window.innerWidth;
    let gridClass = "";
    if (width >= 1440) gridClass = "wishlist-grid-5";
    else if (width >= 1024) gridClass = "wishlist-grid-4";
    else if (width >= 768) gridClass = "wishlist-grid-3";
    else if (width >= 480) gridClass = "wishlist-grid-2";
    else gridClass = "wishlist-grid-1";
    wishlistContainer.className = `wishlist-products-container ${gridClass}`;
  };

  window.addEventListener("resize", updateViewBasedOnScreenSize);
  updateViewBasedOnScreenSize();
}

document.addEventListener('DOMContentLoaded', () => {
  const refButton = document.querySelector('button.button.button--outline.w-full');
  if (!refButton) return;
  const height = window.getComputedStyle(refButton).height;
  document.documentElement.style.setProperty('--btn-height', height);
});